import React, { FC, Fragment, MouseEventHandler, useCallback } from "react";
import { ButtonPrimary } from "../atoms/ButtonPrimary";
import { classNames } from "@/shared/utils/classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/pro-regular-svg-icons";
import { Plan } from "@/app/billing/plan";

export type PlanListItemProps = {
  plan?: Plan;
  isLoading?: boolean;
  onPurchase?: (plan: Plan) => void;
};

export const PlanListItem: FC<PlanListItemProps> = ({
  plan,
  onPurchase,
  isLoading,
}) => {
  const handleClick = useCallback(() => {
    onPurchase?.(plan);
  }, [onPurchase, plan]);

  return (
    <li className="px-4 py-4 sm:px-0 bg-white flex flex-col md:flex-row gap-4">
      <div>
        {isLoading ? (
          <div className="h-64 w-64 bg-gray-300 animate-pulse"></div>
        ) : (
          <img className="h-64 w-64" src={plan?.image} />
        )}
      </div>
      <div className="flex flex-col flex-1">
        {isLoading ? (
          <p className="bg-gray-300 animate-pulse text-primary font-bold text-xl text-transparent">
            Loading...
          </p>
        ) : (
          <p className="text-primary font-bold text-xl">{plan?.name}</p>
        )}
        {isLoading ? (
          <div className="flex flex-col gap-2 mt-4">
            <p className="w-3/4 bg-gray-300 animate-pulse text-primary font-bold text-md text-transparent">
              Loading...
            </p>
            <p className="mt-2 w-2/4 bg-gray-300 animate-pulse text-primary font-bold text-sm text-transparent">
              Loading...
            </p>
            <p className="w-3/4 bg-gray-300 animate-pulse text-primary font-bold text-sm text-transparent">
              Loading...
            </p>
          </div>
        ) : (
          <div>
            <p>{plan?.description}</p>
          </div>
        )}
        <ul className="list-disc">
          {plan?.features?.map((feature: string) => (
            <li className="text-sm ml-4 text-gray-700">{feature}</li>
          ))}
        </ul>
        <div className="justify-end flex mt-4">
          {isLoading ? (
            <div className="w-32 h-8 bg-gray-300 animate-pulse rounded-md"></div>
          ) : (
            <ButtonPrimary
              text={`Comprar por ${plan?.price.currency.toUpperCase()} ${(plan?.price.amount / 100).toFixed(2)}`}
              size="large"
              onClick={handleClick}
            />
          )}
        </div>
      </div>
    </li>
  );
};
